import React from 'react';
import './css/Overview.css';

function Overview() {
  return (
<div style={{ padding: "0 15px" }}>
    <div className="disclaimer">
      <h2>Overview</h2>
      <p>
        Vyral is a private mining facility that has been operational since 2015, specializing in commercial Bitcoin (BTC) mining. They offer not only mining services but also equipment leasing to clients looking to engage in cryptocurrency mining without the hassle of acquiring and managing the hardware themselves.
      </p>
      <p>
        The facility is equipped with state-of-the-art mining hardware and infrastructure, allowing for efficient energy use and high hash rates, which are crucial for profitable mining operations. Their commercial mining solutions provide individuals and businesses with the opportunity to enter the cryptocurrency space while leveraging Vyral's expertise and resources.
      </p>
      <p>
        With the rise of Bitcoin and other cryptocurrencies, facilities like Vyral play a critical role in supporting the broader cryptocurrency ecosystem by providing the necessary equipment and facilities for mining, which is an essential process for securing blockchain networks and validating transactions.
      </p>
      <p>
        Vyral is a prominent private Bitcoin mining facility that has been operating since 2015. Specializing in commercial mining, Vyral offers a comprehensive suite of services including equipment leasing, making it an attractive option for individual and business clients looking to enter the cryptocurrency mining space.
      </p>
      <p>
        The facility boasts the capability to run over 500 miners, utilizing advanced technology to maximize efficiency and productivity. This robust setup allows Vyral to achieve high hash rates, which is essential for successfully mining Bitcoin and ensuring network security.
      </p>
      <p>
        By providing both the infrastructure and expertise needed for effective mining operations, Vyral contributes significantly to the growing cryptocurrency ecosystem. Their commercial leasing options enable clients to participate in mining without the burden of managing hardware, thus making it easier for newcomers and seasoned investors alike to join the Bitcoin mining endeavor.
      </p>
    </div>
</div>
  );
}

export default Overview;